export default function GlasgowComaComponent() {
  return <></>;
}
